import React, { useEffect, useState } from 'react';
import TableContainer from './TableContainer';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
import TopRight from './TopRight';
import BootstrapDateRangePicker from './BootstrapDateRangePicker';
import DashboardLineCharts from './charts/DashboardLineChart';
import configData from "./config.json";
import Cookies from 'js-cookie';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


var CryptoJS = require("crypto-js");

function Dashboard() {

  // eslint-disable-next-line
  const [currency, setCurrency] = useState('USD');

  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [chartImpressionsVsClicks, setChartImpressionsVsClicks] = useState([]);
  const [chartRevenue, setChartRevenue] = useState([]);

  // eslint-disable-next-line
  const [apiError, setApiError] = useState(false);
  const [apiFetched, setApiFetched] = useState(false);

  // Revenue State Variables
  // const [revenue, setRevenue] = useState('loading');
  // eslint-disable-next-line
  const [revenueData, setRevenueData] = useState(0);
  // eslint-disable-next-line
  const [revenueProgress, setRevenueProgress] = useState('');
  const [revenueProgressSign, setRevenueProgressSign] = useState('');

  // eCPM State Variables
  // const [ecpm, setEcpm] = useState('loading');
  // eslint-disable-next-line
  const [ecpmData, setEcpmData] = useState(0);
  // eslint-disable-next-line
  const [ecpmProgress, setEcpmProgress] = useState('');
  const [ecpmProgressSign, setEcpmProgressSign] = useState('');

  // Impressions State Variables
  // const [impressions, setImpressions] = useState('loading');
  const [impressionsData, setImpressionsData] = useState(0);
  // eslint-disable-next-line
  const [impressionsProgress, setImpressionsProgress] = useState('');
  const [impressionsProgressSign, setImpressionsProgressSign] = useState('');

  // Clicks State Variables
  // const [clicks, setClicks] = useState('loading');
  const [clicksData, setClicksData] = useState(0);
  // eslint-disable-next-line
  const [clicksProgress, setClicksProgress] = useState('');
  const [clicksProgressSign, setClicksProgressSign] = useState('');

  // CTR State Variables
  // const [ctr, setCtr] = useState('loading');
  // eslint-disable-next-line
  const [ctrData, setCtrData] = useState('0');
  // eslint-disable-next-line
  const [ctrProgress, setCtrProgress] = useState('');
  const [ctrProgressSign, setCtrProgressSign] = useState('');

  // Request State Variables
  // const [requests, setRequests] = useState('loading');
  // eslint-disable-next-line
  const [requestsData, setRequestsData] = useState(0);
  // eslint-disable-next-line
  const [requestsProgress, setRequestsProgress] = useState('');
  const [requestsProgressSign, setRequestsProgressSign] = useState('');

  function abbrNum(number, decPlaces) {
    decPlaces = Math.pow(10, decPlaces);
    var abbrev = ["K", "M", "B", "T"];
    for (var i = abbrev.length - 1; i >= 0; i--) {
      var size = Math.pow(10, (i + 1) * 3);
      if (size <= number) {
        number = Math.round(number * decPlaces / size) / decPlaces;
        if ((number === 1000) && (i < abbrev.length - 1)) {
          number = 1;
          i++;
        }
        number += abbrev[i];
        break;
      }
    }
    return number;
  }

  // Fetch Data
  const doFetch = async (dt) => {
    // setRevenue('loading');
    // setEcpm('loading');
    // setImpressions('loading');
    // setClicks('loading');
    // setCtr('loading');
    // setRequests('loading');
    setApiFetched(false);
    let reportPostData = '';

    reportPostData = { "sdate": document.getElementById('hiddenDateRange').value.split(' - ')[0], "edate": document.getElementById('hiddenDateRange').value.split(' - ')[1], "email": JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reportPostData),
    };
    try {
      fetch(configData.SERVER_URL+"/dashboard", requestOptions)
        .then(response => {
          return response.json()
        })
        .then(response => {
          if(response.success === false) {
            // alert(response.message);
            toast.error(response.message);
          }else {
            setRevenueProgressSign(revenueProgress.charAt(0));
            setRevenueData(abbrNum(response[0].main.revenue, 2));
            // setRevenue('data');
            setEcpmProgressSign(ecpmProgress.charAt(0));
            setEcpmData(response[0].main.ecpm.toFixed(2));
            // setEcpm('data');
            // setImpressionsData(abbrNum(impressionsData, 2));
            setImpressionsProgressSign(impressionsProgress.charAt(0));
            setImpressionsData(abbrNum(response[0].main.impressions, 2));
            // setImpressions('data');
            // setClicksData(abbrNum(clicksData, 2));
            setClicksProgressSign(clicksProgress.charAt(0));
            setClicksData(abbrNum(response[0].main.clicks, 2));
            // setClicks('data');
            setCtrProgressSign(ctrProgress.charAt(0));
            setCtrData(response[0].main.ctr);
            // setCtr('data');
            setRequestsProgressSign(requestsProgress.charAt(0));
            setRequestsData(abbrNum(response[0].main.requests, 2));
            // setRequests('data');

            let headerColumnArr = [];
            let j = 0;
            for (let key in response[0].report[0]) {
              headerColumnArr[j] = {
                Header: key.replace("_", " "),
                accessor: key,
                Cell: (value) => {
                    if (key === 'revenue') {
                      const keyValue = value.value;
                      return <span><span className="dollar_icon">$</span>{keyValue}</span>
                    } else {
                      return value.value.toLocaleString('en-US');
                    }
                  },
                disableSortBy: false,
                disableFilters: true,
              }
              j++;
            }
            setChartImpressionsVsClicks(response[0].chart.impressions);
            setChartRevenue(response[0].chart.revenue);
            setColumns(headerColumnArr);
            setData(response[0].report);
            setApiFetched(true);
          }


        }).catch(error=>{
          // alert("There is some error in processing your request. Please try again in some time.")
          toast.error("There is some error in processing your request. Please try again in some time.");
        })
    } catch (error) {
      // console.log(`Error! ${error.message}`);
      // alert(error.message);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    doFetch(document.getElementById('hiddenDateRange').value);
    // eslint-disable-next-line
  }, []);

  const pull_data = (data) => {
    if (data === 'dateChanged') {
      doFetch(document.getElementById('hiddenDateRange').value);
    }
  }

  // const pull_data1 = (fm) => {
  //   console.log(fm);
  // }
  
  if(Cookies.get('status')) {
    return (
      <>
        <style>
          {`table tbody{border-bottom: 1px solid #dee2e6 !important;}`}
        </style>
        <div>
        <ToastContainer />
          <div className="d-flex w-100 bg_light">
            <Header />
            <div className="w-100 p-24px">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex mb-28px align-items-center">
                    <div className="header_content">
                      <h1 className="nav_heading">Dashboard</h1>
                    </div>
                    <div className="form_group ms-36px mb-0">
                      <BootstrapDateRangePicker page="dashboard" func={pull_data} />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <TopRight page="dashboard" />
                </div>

              </div>
              <div className="row mb_16px">
                <div className="col-md-4 pe-1">
                  <div className="card_content_data">
                    <div className="bg_blue_light icon_badge mb-25px">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M18.0324 11.9965H14.6588C13.4201 11.9957 12.4161 10.9924 12.4153 9.75374C12.4153 8.51504 13.4201 7.51178 14.6588 7.51102H18.0324" stroke="#5570F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15.0405 9.7024H14.7808" stroke="#5570F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.45637 2.5H13.6592C16.0744 2.5 18.0323 4.45792 18.0323 6.87305V12.8539C18.0323 15.269 16.0744 17.227 13.6592 17.227H6.45637C4.04124 17.227 2.08331 15.269 2.08331 12.8539V6.87305C2.08331 4.45792 4.04124 2.5 6.45637 2.5Z" stroke="#5570F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.86298 6.28181H10.3621" stroke="#5570F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="data_row">
                      <div className="data_dashboard">
                        <h2 className="text_sub_head">Revenue</h2>
                        {/* <b className="heading_data">{(revenue === 'loading') ? ( */}
                        <b className="heading_data">{(!apiFetched) ? (
                          <b className="heading_data"><img src="/assets/media/images/loader.gif" alt="loader" /></b>
                        ) : (
                          <b className="heading_data">{(currency === 'USD') ? ('$') : ('₽')}{revenueData} <span className={(revenueProgressSign === '+') ? ('success') : ('danger')}>{revenueProgress}</span></b>
                        )}</b>
                      </div>
                      <div className="data_dashboard">
                        <h2 className="text_sub_head">eCPM</h2>
                        {/* <b className="heading_data">{(ecpm === 'loading') ? ( */}
                        <b className="heading_data">{(!apiFetched) ? (
                          <b className="heading_data"><img src="/assets/media/images/loader.gif" alt="loader" /></b>
                        ) : (
                          <b className="heading_data">{(currency === 'USD') ? ('$') : ('₽')}{ecpmData} <span className={(ecpmProgressSign === '+') ? ('success') : ('danger')}>{ecpmProgress}</span></b>
                        )}</b>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card_content_data">
                    <div className="bg_success_light icon_badge mb-25px">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M14.3983 11.5743C14.9605 11.5743 15.4325 12.0384 15.3465 12.5936C14.8421 15.8603 12.0456 18.2857 8.67283 18.2857C4.94125 18.2857 1.91669 15.2612 1.91669 11.5305C1.91669 8.45677 4.25177 5.59362 6.88072 4.94625C7.44563 4.80677 8.02458 5.20414 8.02458 5.78572C8.02458 9.72607 8.15704 10.7454 8.90528 11.2998C9.65353 11.8541 10.5334 11.5743 14.3983 11.5743Z" stroke="#00AD1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M18.0772 8.293C18.1219 5.76142 15.0122 1.68072 11.2228 1.75089C10.928 1.75616 10.6921 2.00177 10.6789 2.29563C10.5833 4.37721 10.7122 7.07458 10.7842 8.29738C10.8061 8.67809 11.1052 8.97721 11.485 8.99914C12.7421 9.07107 15.5377 9.16931 17.5894 8.85879C17.8684 8.81668 18.0728 8.57458 18.0772 8.293Z" stroke="#00AD1C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="data_row">
                      <div className="data_dashboard">
                        <h2 className="text_sub_head">Requests</h2>
                        {/* <b className="heading_data">{(requests === 'loading') ? ( */}
                        <b className="heading_data">{(!apiFetched) ? (
                          <b className="heading_data"><img src="/assets/media/images/loader.gif" alt="loader" /></b>
                        ) : (
                          <b className="heading_data">{requestsData} <span className={(requestsProgressSign === '+') ? ('success') : ('danger')}>{requestsProgress}</span></b>
                        )}</b>
                      </div>
                      <div className="data_dashboard">
                        <h2 className="text_sub_head">Impressions</h2>
                        {/* <b className="heading_data">{(impressions === 'loading') ? ( */}
                        <b className="heading_data">{(!apiFetched) ? (
                          <b className="heading_data"><img src="/assets/media/images/loader.gif" alt="loader" /></b>
                        ) : (
                          <b className="heading_data">{impressionsData} <span className={(impressionsProgressSign === '+') ? ('success') : ('danger')}>{impressionsProgress}</span></b>
                        )}</b>
                      </div>
                      <div className="data_dashboard">
                        <h2 className="text_sub_head">Clicks</h2>
                        {/* <b className="heading_data">{(clicks === 'loading') ? ( */}
                        <b className="heading_data">{(!apiFetched) ? (
                          <b className="heading_data"><img src="/assets/media/images/loader.gif" alt="loader" /></b>
                        ) : (
                          <b className="heading_data">{clicksData} <span className={(clicksProgressSign === '+') ? ('success') : ('danger')}>{clicksProgress}</span></b>
                        )}</b>
                      </div>
                      <div className="data_dashboard">
                        <h2 className="text_sub_head">CTR %</h2>
                        {/* <b className="heading_data">{(ctr === 'loading') ? ( */}
                        <b className="heading_data">{(!apiFetched) ? (
                          <b className="heading_data"><img src="/assets/media/images/loader.gif" alt="loader" /></b>
                        ) : (
                          <b className="heading_data">{ctrData} <span className={(ctrProgressSign === '+') ? ('success') : ('danger')}>{ctrProgress}</span></b>
                        )}</b>
                      </div>
                    </div>
                  </div>
                </div>


              </div>

              <div className="row mb_16px">
                <div className='col-md-12'>
                  <div className='card_content_data pb-1'>




                    <DashboardLineCharts
                      chartDataImpressions={chartImpressionsVsClicks}
                      chartDataRevenue={chartRevenue}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className='col-md-12'>
                  <div className='card_content_data'>
                    {/* <TableContainer
                    columns={columns}
                    data={data}
                    apiError={apiError}
                    pageServing="dashboard"
                    defaultSortedColumn='DOMAIN'
                    apiFetch={apiFetched}
                  /> */}
                    <TableContainer
                      columns={columns}
                      data={data}
                      apiError={apiError}
                      pageServing="dashboard"
                      // defaultSortedColumn='DOMAIN'
                      defaultSortedColumn={(columns.length > 0) ? (apiFetched) ? columns[0].accessor : '' : ''}
                      apiFetch={apiFetched}
                      // func={pull_data1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    window.location.href = "/";
  }

}

export default Dashboard;